export default __webpack_public_path__ + "static/media/INICIO.60e5ab74.png";